import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  multicolorBar: props => ({
    margin: props.isRadius ? '0 16px' : 0,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    borderRadius: props.isRadius ? '8px' : '0px',
    overflow: 'hidden',
    '& bars bar': {
      height: '10px',
    },
  }),
  bar: {
    position: 'relative',
    height: '10px',
    '&:hover': {
      borderWidth: '2px',
    },
  },
  bars: {
    display: 'flex',
    flexDirection: 'row',
    gap: '4px',
    height: '10px',
  },
}));
